import React from 'react';
import { LoadingButton } from '@mui/lab';

export const ProspectsActions = ({
    activeStep,
    steps,
    handleBack,
    handleNext,
    handleShowSummary,
    handleCancel,
    handleSubmit,
    isLoading,
}) => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '20px',
            }}
        >
            {activeStep > 0 && (
                <LoadingButton
                    fullWidth
                    size="large"
                    variant="outlined"
                    onClick={handleBack}
                    style={{ flex: '1 1 20%', marginRight: '10px' }}
                >
                    Atrás
                </LoadingButton>
            )}

            {activeStep < steps.length - 1 ? (
                <LoadingButton
                    fullWidth
                    size="large"
                    variant="contained"
                    onClick={handleNext}
                    style={{ flex: '1 1 20%', backgroundColor: '#143f6c' }}
                >
                    Siguiente
                </LoadingButton>
            ) : (
                <>
                    <LoadingButton
                        fullWidth
                        size="large"
                        color="info"
                        variant="contained"
                        onClick={handleShowSummary}
                        style={{ flex: '1 1 20%', marginRight: '10px' }}
                    >
                        Ver Resumen
                    </LoadingButton>

                    <LoadingButton
                        fullWidth
                        size="large"
                        color="error"
                        variant="contained"
                        onClick={handleCancel}
                        style={{ flex: '1 1 20%', marginRight: '10px' }}
                    >
                        Cancelar
                    </LoadingButton>

                    <LoadingButton
                        fullWidth
                        size="large"
                        variant="contained"
                        loading={isLoading}
                        onClick={handleSubmit}
                        style={{ flex: '1 1 20%', backgroundColor: '#143f6c' }}
                    >
                        Registrar Prospección
                    </LoadingButton>
                </>
            )}
        </div>
    );
};
